import React from 'react'

import './Graph.css'

const colors = {
  red: '#D0021B',
  green: '#B8E986',
  blue: '#4A90E2'
}

class Graph extends React.PureComponent {
  canvasEl = null
  height = 200

  update (props) {
    const steps = props.data.length
    const xSize = Math.min(10, props.size / steps)
    const ySize = this.height / props.max

    const ctx = this.canvasEl.getContext('2d')
    ctx.clearRect(0, 0, props.size, this.height)

    if (steps) {
      const enemies = Object.keys(props.data[0])
      enemies.map((enemyId) => {
        ctx.beginPath()
        ctx.strokeStyle = colors[enemyId]
        ctx.moveTo(0, this.height - (props.data[0][enemyId] * ySize))
        props.data.map((data, step) => {
          ctx.lineTo(step * xSize, this.height - (data[enemyId] * ySize))
          return false
        })
        ctx.stroke()
        return false
      })
    }
  }

  componentDidMount() {
    this.update(this.props)
  }
  componentWillReceiveProps(newProps) {
    this.update(newProps)
  }

  render () {
    const graphStyle = {
      width: `${this.props.size}px`,
      height: this.height
    }
    return (
      <canvas width={this.props.size} height={this.height} className={'graph'} style={graphStyle} ref={(el) => this.canvasEl = el}/>
    )
  }
}

export default Graph



// WEBPACK FOOTER //
// ./src/components/Graph.js